export function INIT(state) {
	state.init = true;
}

export function UPDATE_SUBSCRIPTION(state, subscription) {
	Object.assign(state, subscription);
}

export function SET_INVOICES(state, invoices) {
	state.invoices = invoices;
}

export function SET_INVOICES_LOADING(state, isLoading) {
	state.invoicesLoading = isLoading;
}
